import { DataConfig } from '@aibees/elephant/components/sortable-table';
import { BuyingTeamMatrixItemValue } from '@aibees/elephant/feature/buying-team-matrix';
import { ElephantPresetType } from '@aibees/elephant/types';
import { useBrowsePresetApi } from '@aibees/shared/api';
import { ParsedPreset } from '@aibees/shared/definition';
import { jsonParse } from '@aibees/shared/utils';
import { sortBy } from 'lodash-es';
import { useMemo } from 'react';

export function useBrowseBuyingTeamsApi() {
  const orderBrowseApi = useBrowsePresetApi<string[]>({
    type: ElephantPresetType.BUYING_TEAM_MATRIX_ORDER,
    size: 1,
    sort: 'created:desc',
  });

  const api = useBrowsePresetApi<BuyingTeamMatrixItemValue>(
    {
      type: ElephantPresetType.BUYING_TEAM_MATRIX,
      size: 25,
    },
    {
      queryKey: [
        useBrowsePresetApi.name,
        ElephantPresetType.BUYING_TEAM_MATRIX,
        orderBrowseApi.data?.content.at(0)?.value,
      ],
      select: (data) => {
        const order = orderBrowseApi.data?.content.at(0)?.value;
        data.content = data?.content.map((x: ParsedPreset<DataConfig>) => {
          if (typeof x.value === 'string') x.value = jsonParse(x.value);
          return x;
        });
        data.content = sortBy(data.content, (c) => {
          return order?.indexOf(c.id);
        });
        return data;
      },
    }
  );

  const idList = api.data?.content.map((x) => x.id);

  return useMemo(() => {
    return {
      ...{ orderBrowseApi },
      ...{
        matrixBrowseApi: api,
      },
      ...{ idList },
    };
  }, [api, idList, orderBrowseApi]);
}
